import React from 'react';
import Slider from "@material-ui/core/Slider";
import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	timeRange: {
		fontSize: 12,
        paddingTop: theme.spacing(2)
	}
}));

const WorkingTimeInput = ({value, onChange}) => {

    const max = 60 * 24;
	const classes = useStyles();

    if (!onChange) {
        onChange = (e) => {};
    }

    const valuetext = (value) => {
        if (isNaN(value)) {
            return '';
        }
        let hours = Math.floor(value / 60);
        let minutes = value - hours * 60;
        return (hours < 10 ? '0' : '')  + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
    }

    const inversed = () => {
        return value.Inversed
    }

	return (
         <Grid container>

             {value &&
                 <>
            <Grid item xs={6}>
                <Box m={1}>
                    <Slider
                        value={[value.From, value.To]}
                        onChange={(e, v) => { onChange({ From : v[0], To: v[1], Inversed: value.Inversed })}}
                        valueLabelDisplay="auto"
                        getAriaValueText={valuetext}
                        valueLabelFormat={valuetext}
                        min={0}
                        step={15}
                        max={max}
                        track={inversed() ? 'inverted' : 'normal'}
                  />
                </Box>
            </Grid>
            <Grid item xs={4} className={classes.timeRange}>
                {!inversed() && <>
                    {valuetext(value.From)} - {valuetext(value.To)}
                </>}
                {inversed() && <>
                    00:00-{valuetext(value.From)}, {valuetext(value.To)}-24:00
                </>}
            </Grid>
            <Grid item xs={2}>
                <Box m={1}>
                    <Switch size="small"
                            color="primary"
                            value={inversed()}
                            checked={inversed()}
                            onChange={e => onChange(Object.assign({}, value, { Inversed: e.target.checked }))}
                    />
                </Box>
            </Grid></>}
        </Grid>
	);
}

export default WorkingTimeInput;